import * as React from 'react'
import { PartialContainer } from 'components'
export const InflationHedgeDiversify = () => {
  return (
    <div className="bg-[#F7F7F7]">
      <PartialContainer>
        <div className="pt-8 lg:px-32 lg:py-44">
          <div className="mx-auto flex w-full flex-col items-center justify-center px-6 lg:w-4/5 lg:px-0">
            <h2 className="text-center font-heading text-2xl font-extrabold text-[#282231] lg:text-5xl">
              We can help you diversify.
            </h2>
            <p className="mb-5 pt-4 text-center font-heading text-lg font-semibold text-[#374151] lg:mb-16 lg:text-lg">
              Compare this product with other common investments.
            </p>
          </div>
          <div className="flex w-full flex-col items-center justify-between lg:flex-row">
            <div className="mb-12 w-full rounded rounded-md bg-white text-center shadow-md lg:mb-0 lg:mr-8">
              <div className="flex flex-col items-center border border-b border-l-0 border-r-0 border-t-0 border-[#E6E6E6] lg:flex-row">
                <div className="flex min-h-[100px] w-full items-center justify-center rounded-tl-md rounded-tr-md bg-[#58595B] px-12 text-sm text-white lg:w-1/5 lg:rounded-tl-md lg:rounded-tr-none">
                  <h1 className="font-bold">INVESTMENT PRODUCT</h1>
                </div>
                <div className="flex min-h-[100px] w-full items-center justify-center border border-b border-l-0 border-t-0 border-[#E6E6E6] px-2 text-sm font-bold text-[#58595B] lg:w-1/5 lg:border-b-0 lg:border-r">
                  <h1>Checking / Saving Account</h1>
                </div>
                <div className="flex min-h-[100px] w-full items-center justify-center border border-b border-l-0 border-r-0 border-t-0 border-[#E6E6E6] px-2 text-sm font-bold text-[#58595B] lg:w-1/5 lg:border-b-0 lg:border-r">
                  <h1>US Treasury Bills, Notes</h1>
                </div>
                <div className="flex min-h-[100px] w-full items-center justify-center border border-b border-l-0 border-r-0 border-t-0 border-[#E6E6E6] px-6 text-sm font-bold text-[#58595B] lg:w-1/5 lg:border-b-0 lg:border-r">
                  <h1>Equities (S&P 500)</h1>
                </div>
                <div className="flex min-h-[100px] w-full items-center justify-center px-4 text-sm font-bold text-[#58595B] lg:w-1/5 ">
                  <h1>PE / VC Generalist Funds</h1>
                </div>
              </div>
              <div className="flex flex-col items-center border border-b border-l-0 border-r-0 border-t-0 border-[#E6E6E6] lg:flex-row">
                <div className="flex min-h-[100px] w-full items-center justify-center bg-[#58595B] px-12 text-white lg:w-1/5">
                  <h1 className="text-sm font-bold ">ANNUALIZED RETURN</h1>
                </div>
                <div className="flex min-h-[100px] w-full items-center justify-center border border-b border-l-0 border-r-0 border-t-0 border-[#E6E6E6] text-sm text-[#58595B] lg:w-1/5 lg:border-b-0 lg:border-r">
                  <h1>0 - 0.5%</h1>
                </div>
                <div className="flex min-h-[100px] w-full items-center justify-center border border-b border-l-0 border-r-0 border-t-0 border-[#E6E6E6] text-sm text-[#58595B] lg:w-1/5 lg:border-b-0 lg:border-r">
                  <h1>5%</h1>
                </div>
                <div className="flex min-h-[100px] w-full items-center justify-center border border-b border-l-0 border-r-0 border-t-0 border-[#E6E6E6] text-sm text-[#58595B] lg:w-1/5 lg:border-b-0 lg:border-r">
                  <h1>~8%</h1>
                </div>
                <div className="flex min-h-[100px] w-full items-center justify-center text-sm text-[#58595B] lg:w-1/5">
                  <h1>10 - 12%</h1>
                </div>
              </div>
              <div className="flex flex-col items-center lg:flex-row">
                <div className="flex min-h-[90px] w-full items-center justify-center bg-[#58595B] px-12 text-white lg:min-h-[213px] lg:w-1/5 lg:rounded-bl-md">
                  <h1 className="text-sm font-bold">BENEFITS</h1>
                </div>
                <div className="flex min-h-[90px] w-full items-center justify-center border border-b border-l-0 border-r-0 border-t-0 border-[#E6E6E6] lg:min-h-[213px] lg:w-1/5 lg:border-b-0 lg:border-r">
                  <ul className="py-5 text-sm text-[#58595B] lg:py-0">
                    <li className="pb-7">Liquid</li>
                    <li className="pb-7">-</li>
                    <li>-</li>
                  </ul>
                </div>
                <div className="flex min-h-[90px] w-full items-center justify-center border border-b border-l-0 border-r-0 border-t-0 border-[#E6E6E6] lg:min-h-[213px] lg:w-1/5 lg:border-b-0 lg:border-r">
                  <ul className="py-5 text-sm text-[#58595B] lg:py-0">
                    <li className="pb-7">Liquid</li>
                    <li className="pb-7">-</li>
                    <li>-</li>
                  </ul>
                </div>
                <div className="flex min-h-[90px] w-full items-center justify-center border border-b border-l-0 border-r-0 border-t-0 border-[#E6E6E6] lg:min-h-[213px] lg:w-1/5 lg:border-b-0 lg:border-r">
                  <ul className="py-5 text-sm text-[#58595B] lg:py-0">
                    <li className="pb-7">-</li>
                    <li className="pb-7">Inflation Hedge</li>
                    <li>Diversified</li>
                  </ul>
                </div>
                <div className="flex min-h-[90px] w-full items-center justify-center lg:min-h-[213px] lg:w-1/5">
                  <ul className="py-5 text-sm text-[#58595B] lg:py-0">
                    <li className="pb-7">-</li>
                    <li className="pb-7">Inflation Hedge</li>
                    <li>Diversified</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="w-full rounded rounded-md bg-white shadow-md lg:w-[20%]">
              <h1 className="flex min-h-[100px] items-center justify-center px-4 py-5 text-center text-sm font-semibold text-[#58595B]">
                MarketX Ventures Structured Product
              </h1>
              <h1 className="flex min-h-[100px] items-center justify-center bg-gradient-to-r from-[#552C90] to-[#45ACD8] px-4 py-5 text-center text-sm font-semibold text-white">
                24.50%
              </h1>
              <div className="flex min-h-[100px] items-center justify-center text-center lg:min-h-[213px]">
                <ul className="py-5 text-sm text-[#58595B] lg:py-0">
                  <li className="pb-7">Enhanced</li>
                  <li className="pb-7">Inflation Hedge</li>
                  <li>Diversified</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </PartialContainer>
    </div>
  )
}
